import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReportField, ReportFieldTypeMapper, ReportFieldTypesEnum } from '../../../api/models/report-field';

@Component({
  selector: 'app-report-fields',
  templateUrl: './report-fields.component.html',
  styleUrl: './report-fields.component.scss',
  standalone: false
})
export class ReportFieldsComponent implements OnInit {
  @Input() reportFields : ReportField[] = [];
  @Input() initiallySelectedFields : ReportField[] = [];
  @Input() groupId : string = '';
  @Input() reportFieldsMapper: Record<ReportFieldTypesEnum, string> = ReportFieldTypeMapper
  @Input() disableSelection: boolean = false

  @Output() selectedFieldsChanged = new EventEmitter<ReportField[]>();

  selectedFields : Map<string, ReportField> = new Map();
  formattedFields : Map<string, ReportField[]> = new Map();

  ngOnInit(): void {
    this.initiallySelectedFields.map(field => {
      this.selectedFields.set(field.id, field);
    });

    this.formatFields();
  }

  formatFields() {
    for (const reportField of this.reportFields) {
      const displayType = this.reportFieldsMapper[reportField.type];

      if (!this.formattedFields.has(displayType)) {
        this.formattedFields.set(displayType, []);
      }
      this.formattedFields.get(displayType)?.push(reportField);
    }
  }

  onStateChange(value: ReportField) {
    if (!this.disableSelection) {
      if (this.selectedFields.has(value.id)) {
        this.selectedFields.delete(value.id);
      } else {
        this.selectedFields.set(value.id, value);
      }
  
      this.selectedFieldsChanged.emit(Array.from(this.selectedFields.values()));
    }
  }
}
